import { plainToClassFromExist, Expose, Transform } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnColorPalette } from '@lib/common/types';
import { SnBadge } from '@lib/ui/badge';
import { SnIcon } from '@lib/ui/icon';
import { SnMenu } from '@lib/ui/menu';
import { SnTooltip } from '@lib/ui/tooltip';

import { SnSmartButtonType } from '../enums/smart-button-type.enum';
import { SnSmartButtonConfig } from '../types/smart-button-config';

export class SnSmartButton {
  @Expose() public type: SnSmartButtonType;

  @Expose() public label: string;
  @Expose() public url: string;
  @Expose() @Default(false) public disabled: boolean;

  @Expose()
  @Transform((value, data) => SnIcon.fromConfig(data.icon))
  public icon: SnIcon;

  @Expose()
  @Transform((value, data) => SnBadge.fromConfig(data.badge))
  public badge: SnBadge;

  @Expose()
  @Transform((value, data) => SnTooltip.fromConfig(data.tooltip))
  public tooltip: SnTooltip;

  @Expose()
  @Transform((value, data) => SnMenu.fromConfig(data.menu))
  public menu: SnMenu;

  @Expose() public color: SnColorPalette;
  @Expose() @Default(false) public outlined: boolean;
  @Expose() @Default(false) public unelevated: boolean;

  public click: (event?: MouseEvent) => void;

  constructor(public readonly name: string, config: SnSmartButtonConfig) {
    this.click = config.click;

    plainToClassFromExist(this, config, { strategy: 'excludeAll' });
  }
}
